import AboutUsComponent from "../NonMVPComponents/AboutUsComponent";

const AboutUs = () => {
  return (
    <div>
      <AboutUsComponent />
    </div>
  );
};

export default AboutUs;
